export default __webpack_public_path__ + "static/media/photo2.35828d13.jpg";